import { useEffect, useMemo, useState } from 'react';
import axios from '../api';

export default function Downloads() {
  const [categories, setCategories] = useState([]);
  const [files, setFiles] = useState([]);
  // '' = nothing selected yet; '__all__' = user explicitly selected all
  const [cat, setCat] = useState('');

  const sortedCategories = useMemo(() => {
    return [...(categories || [])].sort((a, b) => {
      const an = String(a?.name || '').trim();
      const bn = String(b?.name || '').trim();
      return an.localeCompare(bn, 'de', { sensitivity: 'base' });
    });
  }, [categories]);

  const formatSize = (bytes) => {
    const n = Number(bytes);
    if (!Number.isFinite(n) || n < 0) return '-';

    // Requested thresholds: 1000 KB => MB, 1000 MB => GB
    const KB = 1000;
    const MB = 1000 * KB;
    const GB = 1000 * MB;

    if (n >= GB) return `${(n / GB).toFixed(1)} GB`;
    if (n >= MB) return `${(n / MB).toFixed(1)} MB`;
    return `${(n / KB).toFixed(1)} KB`;
  };

  useEffect(() => {
    axios.get('/uploads/public/categories').then(res => setCategories(res.data.items || []));
  }, []);

  useEffect(() => {
    if (!cat) {
      setFiles([]);
      return;
    }
    const qs = cat === '__all__' ? '' : `?categoryId=${cat}`;
    axios.get(`/uploads/public/files${qs}`).then(res => setFiles(res.data.items || [])).catch(() => setFiles([]));
  }, [cat]);

  const onDownload = async (file) => {
    try {
      const url = `/uploads/public/files/${file.id}/download`;
      const res = await axios.get(url, { responseType: 'blob' });
      const blob = new Blob([res.data], { type: res.headers['content-type'] || 'application/octet-stream' });
      // Try to extract filename from Content-Disposition
      let filename = file.title || 'download';
      const cd = res.headers['content-disposition'] || res.headers['Content-Disposition'];
      if (cd) {
        const m = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(cd);
        if (m) filename = decodeURIComponent(m[1] || m[2] || filename);
      }
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        URL.revokeObjectURL(link.href);
        link.remove();
      }, 0);
    } catch (e) {
      alert('Download fehlgeschlagen. Bitte erneut versuchen oder Admin informieren.');
    }
  };

  return (
    <div className="home-page">
      {/* Hero header */}
      <section style={{ width:'100vw', margin:0, padding:0, position:'relative', left:'-120px' }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Downloads</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign: 'center', maxWidth:760 }}>Freigegebene Dateien aus deinen Kategorien herunterladen.</p>
      </section>
      {/* Centered content */}
      <section style={{ width: '100%', maxWidth: 900, margin: '0 auto', padding: '0 16px 40px 16px', color: '#fff' }}>
        <div style={{ marginBottom: 8 }}>
          Kategorie: <select value={cat} onChange={e=>setCat(e.target.value)}>
            <option value="" disabled>— bitte wählen —</option>
            <option value="__all__">— alle —</option>
            {sortedCategories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>
        <ul>
          {cat === '' && (
            <li style={{ color: '#ccc' }}>
              Bitte wähle eine Kategorie (oder „alle“), um Downloads anzuzeigen.
            </li>
          )}
          {files.map(f => (
            <li key={f.id}>
              <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                {f.thumbnailFilename && (
                  <img
                    src={`${import.meta.env.VITE_API_URL || 'http://localhost:5000'}/uploads/files/${f.thumbnailFilename}`}
                    alt={f.title}
                    style={{ width:72, height:72, objectFit:'cover', borderRadius:6, border:'1px solid rgba(255,255,255,0.1)' }}
                  />
                )}
                <div>
                  <b>{f.title}</b> — {formatSize(f.fileSize)} — {f.fileType}
                  {f.description && <div style={{ fontSize: 12, color: '#ccc' }}>{f.description}</div>}
                  <button onClick={()=>onDownload(f)} style={{ marginTop: 6 }}>Download</button>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
